/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import '../../crp_meta_ui/elements/error-component.js';
import "./fin-page-footer.js";
const template = html`
<custom-style>
  <style include="login-styles">
  /* MB style */
  @media (max-width: 479px){
      .mb-margin{
        margin: 0px !important;
      } 
  }
  .mb-margin{
    margin:23%;
} 
    :dir(ltr) .message {
      margin-left: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-right: 4%; */
    }
	
	:dir(rtl) .message {
      margin-right: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-left: 4%; */
    }
	
	.stealthy{
				display: none;
                left: 0;
                margin: 0;
                max-height: 1px;
                max-width: 1px;
                opacity: 0;
                outline: none;
                overflow: hidden;
                pointer-events: none;
                position: absolute;
                top: 0;
                z-index: -1;
            }
    .align-ev-input {
      text-align:left;
      margin-left:16px;
      margin-right:16px;
    }
		:dir(rtl) .stealthy{
			display: none;
			right: 0;
			left: auto;
			margin: 0;
			max-height: 1px;
			max-width: 1px;
			opacity: 0;
			outline: none;
			overflow: hidden;
			pointer-events: none;
			position: absolute;
			top: 0;
			z-index: -1;
        }
    	@media all and (-ms-high-contrast:none)
      	{
		oe-input {
          		--paper-input-container-label: {
              			top: -4px;
            		}
          	}
      	}
          app-dialog{
              --iron-input: {
                display:none !important;
              }
          }

          .center-image{
			  margin-left: 30%;
		  }
          .imgstyle{
              height:50px;
              width:100px;
          }
          .descriptionStyle{
            border: 2px solid teal;
            padding: 2px 8px 2px 7px;
            border-radius: 20px;
          }
          .iron-icon-terms{
            height: 30px;
            width: 30px;
          } 
          .blurClass{
            filter: blur(5px);
          }
          .font30{
            font-size: 30px;
          }
          .otp-expiry-countdown{
            color: var(--critical-label-color);
          }
  </style>
  </custom-style>
  <oe-ajax id="crontoValidate" method="post" content-type="application/json" on-response="handleResponse" on-error="handleError"></oe-ajax>
  <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
  <div style=""><error-component></error-component></div>
  <div id="main-container" class="full-height light-background">
    <div class="mdl-grid " style="border-bottom:2px solid #dbdfe8;padding: 20px 15px" >
        <div class="mdl-cell mdl-cell--2-col">
            <div class="content-align-vertical-center mb-margin" >
                <iron-icon class="iron-icon-style-s cursor-pointer" icon="icons:arrow-back" on-tap="goToBackpage" style="color:#04859C;"></iron-icon> 
                <oe-i18n-msg class="cursor-pointer font-size-l"  msgid="b_Back" style="color:#04859C" on-tap="goToBackpage"></oe-i18n-msg>
            </div>
        </div>
        <div class="layout mdl-cell mdl-cell--8-col vertical">
            <div class="content-align-center font30 font-weight-bold mdl-cell mdl-cell--12-col">
                <oe-i18n-msg msgid="l_scanSecureImage"></oe-i18n-msg>
            </div>
            <div class="font-18 content-align-center mdl-cell mdl-cell--12-col">
                <oe-i18n-msg msgid="l_scanSecureImageDes"></oe-i18n-msg>
            </div>
        </div>
        <div class="mdl-cell mdl-cell--2-col"></div>
    </div>
    <div class="  mdl-cell mdl-cell--12-col margin-b-zero light-background" style="padding: 3%;">      
        <div id="imageClass" class="content-align-center">
            <img src="{{crontoData}}" alt="Green dot" style="height: 260px;"/>         
        </div>
        <div class="font-18 content-align-center mdl-cell mdl-cell--12-col" style="margin-top: 20px;" hidden$={{!timeOutTxtFlag}}>
            <oe-i18n-msg msgid="l_waitingForResponse"></oe-i18n-msg>
        </div>
        <div class="content-align-center mdl-cell mdl-cell--12-col" hidden$={{timeOutTxtFlag}}>
                <oe-i18n-msg class="font-24 font-weight-700" msgid="l_TxnImgExpiredNote"></oe-i18n-msg>
        </div>
        <div class="font-18 content-align-center mdl-cell mdl-cell--12-col" style="margin-top: 20px;" hidden$={{timeOutTxtFlag}}>
            <oe-i18n-msg msgid="l_regTimeoutMsgNote"></oe-i18n-msg>
        </div> 
        <div class="mdl-cell--12-col horizontal layout content-align-center">
            <div class="content-align-center">
                <div class="content-align-horizontal-end font-18 mdl-cell--12-col" style="padding-left: 25px;padding-top:20px;">
                    <oe-i18n-msg msgid="h_registrationTimeoutMsg"></oe-i18n-msg>
                    <span class="content-align-horizontal-end otp-expiry-countdown" id="time">&nbsp;&nbsp;{{countDownTime}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="">
        <div class=" light-background" style="height: 35%;padding-left: 3%;"></div>
        <div class="mdl-cell--12-col mdl-grid light-background"></div>
        <fin-page-footer/>
    </div>

  </div> 


  `;
Polymer({
    is: 'fin-auth-qr-code',
    _template: template,
    properties: {
        wrapperValue: {
            type: String,
            value: '',
            notify: true
        },
        showError: {
            type: Boolean,
            value: false,
            notify: true,
            observer: "toggleErrorMessage"
        },
        errorMessage: {
            type: String,
            value: "Minimum 6 and maximum 12 characters",
            notify: false
        },
        showCrontoImageFlag: {
            type: Boolean,
            value: false,
            notify: true
        },
        pattern: {
            type: String,
            value: "((?! ).)*",
            notify: false
        },
        minlength: {
            type: Number,
            value: 6,
            notify: false
        },
        maxlength: {
            type: Number,
            value: 12,
            notify: false
        },
        label: {
            type: String,
            value: "Transaction Password",
            notify: false
        },
        wrapperValueInput: {
            type: String,
            value: '',
            notify: true,
            observer: 'inputValueChanged'
        },
        isvalid: {
            type: Boolean,
            value: true,
            notify: true
        },
        required: {
            type: Boolean,
            notify: true
        },
        selectedFlag: {
            type: Boolean,
            notify: true,
            value: false
        },
        selectedLoginPage: {
            type: Number,
            notify: true,
            observer: '_timedApiCall'
        },
        selectedPage: {
            type: Number,
            notify: true
        },
        crontoResponse: {
            type: Object,
            notify: true,
            observer: '_setCrontoData'
        },
        crontoData: {
            type: String,
            value: '',
            notify: true,
        },
        dataBody: {
            type: Object,
            notify: true
        },
        qrResponse: {
            type: Object,
            notify: true,
            observer: '_checkSuccess'
        },
        fromQr: {
            type: Boolean,
            notify: true,
            value: false
        },
        fromPlaystore: {
            type: Boolean,
            notify: true,
            value: false
        },
        timeInterval: {
            type: Number,
            notify: true
        },
        timeIntervalLimit: {
            type: Number,
            notify: true
        },
        timeOutTxtFlag: {
            type: Boolean,
            value: true,
            notify: true
        },
        countDownTime: {
            type: String
        },
        enableOtpCounter: {
            type: Boolean,
            value: false
        }
    },
    ready: function () {
    },
    attached: function () {
    },
    goToBackpage() {
        clearInterval(this.interval);
        this.selectedLoginPage = 0;
        this.selectedFlag = false;
        this.selectedPage = 0;
        this.fromPlaystore = true;
        clearTimeout(this.timeOut);
    },
    _setCrontoData() {
        if (this.crontoResponse.crontoImageData != undefined) {
            this.crontoData = "data:image/png;base64," + this.crontoResponse.crontoImageData;
            this.timeOutTxtFlag = true;
            this.shadowRoot.querySelector('#imageClass').classList.remove('blurClass');
        }
    },
    _timedApiCall() {
        if (this.selectedLoginPage == 1 && this.selectedFlag == true) {
            if (config.SpeedBoat.App.authInterval) {
                this.timeInterval = config.SpeedBoat.App.authInterval.intervalSecs;
                this.timeIntervalLimit = config.SpeedBoat.App.authInterval.intervalSecsLimit;
            }
            var self = this;
            this.deviceRegistrationTimer();
            self.enableOtpCounter = true;
            this.interval = setInterval(function () {
                self.apicall()
            }.bind(this), 1000 * this.timeInterval)
            this.timeOut = setTimeout(function () {
                self.stopApicall()
            }.bind(this), 1000 * this.timeIntervalLimit)/* 5mins*/
        }
    },
    handleResponse: function (e) {
        this.qrResponse = e.detail.response;
    },
    apicall() {
        if (this.crontoResponse.ochTransactionId != undefined) {
            var Data = JSON.parse(this.dataBody);
            Data.ochTransactionId = "";
            Data.ochTransactionId = this.crontoResponse.ochTransactionId;
            this.$.crontoValidate.body = JSON.stringify(Data);
            this.$.crontoValidate.url = "/auth/customloginpushandcorntoauthetcate";
            this.$.crontoValidate.generateRequest();
        }
    },
    stopApicall() {
        clearInterval(this.interval);
        this.shadowRoot.querySelector('#imageClass').classList.add('blurClass');
        this.timeOutTxtFlag = false;
        this.fire("oe-show-error", getLabel("l_regFailedTimeoutInfo"));
        setTimeout(() => {
            clearInterval(this.interval);
            this.selectedLoginPage = 0;
            this.selectedFlag = false;
            this.selectedPage = 0;
            this.fromPlaystore = true;
            clearTimeout(this.timeOut);
            document.querySelector("ev-login").selectedPage = 0;
            document.querySelector("ev-login").goToCancel();
        }, 3000);
    },
    _checkSuccess() {
        if (this.qrResponse != undefined) {
            if (this.qrResponse.status.cmCode == "SUC") {
                this.selectedLoginPage = 2;
                clearInterval(this.interval);
                clearTimeout(this.timeOut);
            }
            else if (this.qrResponse.status.cmCode == "FAL") {
                clearInterval(this.interval);
                clearTimeout(this.timeOut);
                this.fire("oe-show-error", getLabel("l_regFailedInfo"));
                //this.fire("call-error", 'try again!!!!!!'); 
            }
        }
    },
    _checkSuc() {
        this.selectedLoginPage = 2;
    },
    deviceRegistrationTimer() {
        this.countDownTime = undefined;
        this.otpExpTime = config.SpeedBoat.App.authInterval.intervalSecsLimit;
        this.startTimer(this.otpExpTime);
        this.enableOtpCounter = true;
        this.resendOtpDisabled = true;
        // setTimeout(function () {
        //     self.resendOtpDisabled = false
        // }, 1000 * this.otpExpTime)
    },
    startTimer: function (duration) {
        var self = this;
        var timer = duration;
        if (typeof this.worker1 != "undefined") {
            this.worker1.terminate();
        }
        var blobURL = URL.createObjectURL(new Blob([`
          var timer = `+ timer + `,
            minutes,
             seconds;
             var myVar = null;
             myVar = setInterval(function () {
             minutes = parseInt(timer / 60, 10);
             seconds = parseInt(timer % 60, 10);

             minutes = minutes < 10 ? "0" + minutes : minutes;
             seconds = seconds < 10 ? "0" + seconds : seconds;
             countDownTime = minutes + "m " + seconds + "s";
             postMessage( minutes + "m " + seconds + "s");
             --timer;    
             }, 1000);`], {
            type: "application/javascript"
        }));
        this.worker1 = new Worker(blobURL);

        this.worker1.onmessage = function (event) {
            if (--timer >= 0) {
                self.countDownTime = event.data;
            } else {
                self.enableOtpCounter = false;
                self.resendOtpDisabled = false;
                window.removeListners();
                self.worker1.terminate();
            }
        };
    }
});